  export function CompteurPlaces({ occupes = 78, total = 150 }) {
  const pct     = Math.round((occupes / total) * 100);
  const dispo   = total - occupes;
  const barClass = pct >= 100 ? 'full' : pct >= 80 ? 'warn' : '';
  return (
    <div className="vv-compteur">
      <div className="vv-compteur-label">Places parking</div>
      <div className="vv-compteur-numbers">
        <span className="vv-compteur-current">{occupes}</span>
        <span className="vv-compteur-sep">/</span>
        <span className="vv-compteur-total">{total}</span>
      </div>
      <div className="vv-compteur-bar-wrap">
        <div className={`vv-compteur-bar ${barClass}`} style={{ width: `${pct}%` }} />
      </div>
      <div className="vv-compteur-dispo">
        <strong>{dispo}</strong> places disponibles
      </div>
    </div>
  );
}

export default CompteurPlaces;